/** @jsx jsx */
import { jsx } from 'theme-ui';
import { Box, Flex } from 'rebass';
import { IDESLogo } from './IDESLogo';
import { ISDCLogo } from './ISDCLogo';
import { AwardsLogo } from './AwardsLogo';
import { IXDALogo } from './IXDALogo';
import { Container } from '../Container';

const IXDALogoBox = () => (
  <Container py={[2, 3, 3]}>
    <Flex alignItems="baseline" justifyContent="space-between" flexWrap="wrap">
      <Flex
        justifyContent={['center', 'flex-start']}
        p={[2, null]}
        width={[1 / 2, 1 / 4]}
      >
        <IXDALogo width={['130px']} />
      </Flex>
      <Flex justifyContent={['center']} p={[2, null]} width={[1 / 2, 1 / 4]}>
        <AwardsLogo width={['130px']} />
      </Flex>
      <Flex justifyContent={['center']} p={[2, null]} width={[1 / 2, 1 / 4]}>
        <IDESLogo width={['130px']} />
      </Flex>
      <Flex
        justifyContent={['center', 'flex-end']}
        p={[2, null]}
        width={[1 / 2, 1 / 4]}
      >
        <ISDCLogo width={['130px']} />
      </Flex>
    </Flex>
  </Container>
);

export { IXDALogoBox };
